export default __webpack_public_path__ + "static/media/testimonials-2.8732aa37.jpg";